var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetflix = function SvgNetflix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 149 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#netflix_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E50914",
    fillRule: "evenodd",
    d: "M0 0h5.935l8.227 22.593V0h6.282v37.487s-4.081.3-6.875.756L6.343 17.516v21.613S1.465 39.782 0 40zm26.492 36.92s15.345-1.31 17.368-1.292v-6.133s-8.742.524-11.092.706v-9.294h8.471V14.68h-8.511V6.282h11.15V0h-17.38zM47.923 0h19.383v6.299H60.78v28.634s-4.534.09-6.285.2V6.29h-6.579zM71.35 0h17.503v6.293h-11.19v8.03h8.43v6.152h-8.381v14.298s-3.558-.032-6.368 0zm21.542 0h6.221v29.15s8.39.395 10.768.592v6.19s-13.52-.837-17.005-.798zm22.231 0h6.223v36.808s-5.281-.54-6.291-.533zm11.518 0h6.796l4.079 10.55L142.099 0h6.869l-8.185 18.986L148.968 40s-5.981-.878-7.127-.958l-4.61-11.792-4.664 10.661s-5.103-.575-6.539-.666l7.954-18.406z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "netflix_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h149v40H0z"
  })))));
};
export default SvgNetflix;